import { usersApi } from 'api/users'
import { Fields as UserProfile } from 'models/UserProfile'
import { useState } from 'react'

export const useGiftCards = (profile: UserProfile) => {
  const [currentPage, setCurrentPage] = useState(1)

  const { data, isFetching } = usersApi.useGetUserGiftCardsQuery({
    userUid: profile.uid,
    page: currentPage,
  })

  const giftCards = data?.gift_cards ?? []
  const numPages = data?.pagination?.total_pages ?? 1

  const onChangePage = (page: number) => {
    window.scrollTo(0, 0)
    setCurrentPage(page)
  }

  return {
    isFetchingGiftCards: isFetching,
    currentPage,
    numPages,
    giftCards,
    onChangePage,
  }
}
